module.exports = __webpack_public_path__ + "static/media/foto11.3aed9cb1.JPG";